import { FilterNames } from '../../constants';
import AbstractRangeFilterHandler from '../../../shop-ui/includes/filter-state/AbstractRangeFilterHandler';
import { IFilterStateHandler, ISelectFilterOption, IRangeFilter } from '../../../shop-ui/components/search-page/interfaces';

export default class CapacityFilterHandler extends AbstractRangeFilterHandler implements IFilterStateHandler {
    public createQueryParams = (filter: IRangeFilter, params: object): void => {
        if (filter.activeMax !== filter.max || filter.activeMin !== filter.min) {
            params[FilterNames.CAPACITY + '[min]'] = filter.activeMin.toString();
            params[FilterNames.CAPACITY + '[max]'] = filter.activeMax.toString();

            return;
        }

        this.resetQueryParams(params);
    }

    public resetQueryParams = (params: object): void => {
        params[FilterNames.CAPACITY + '[min]'] = null;
        params[FilterNames.CAPACITY + '[max]'] = null;
    }

    public getSelectedOptions = (_filter: IRangeFilter): ISelectFilterOption[] => []

    public updateSelectedOptions = (filter: IRangeFilter, selectedValues: number[]): void => {
        filter.activeMin = selectedValues[0] ?? filter.min;
        filter.activeMax = selectedValues[1] ?? filter.max;
    }
}
